import { render } from "./VehiclesData.vue?vue&type=template&id=9303db10"
import script from "./VehiclesData.vue?vue&type=script&lang=js"
export * from "./VehiclesData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__